import { ResponseEntity } from "domain/entity/Common/ResponseEntity";
import { MovementPatternDtlEntity } from "domain/entity/MovementPattern/MovementPatternDtlEntity";
import { MovementPatternEntity } from "domain/entity/MovementPattern/MovementPatternEntity";
import { axiosGetData, axiosPostData } from "../axios/AxiosBasicImpl";
import referenceAxiosInstance from "../axios/referenceAxiosInstance";
import { MovementPatternRepository } from "./MovementPatternRepo";

export const MovementPatternRepoImpl = (): MovementPatternRepository => {


    const searchAllMovementPatternList = async (): Promise<MovementPatternEntity[]> => {
        const searchUrl = "/v1/movementPattern"
        return axiosGetData(referenceAxiosInstance, `${searchUrl}`, []).then(res => {
            const data = res.data;
            return data;
        }).catch(err => {
            return [];
        });
    }
    const searchMovementPatternDtlList = async (key: number): Promise<MovementPatternDtlEntity[]> => {
        const searchUrl = "/v1/movementPatternDtl"
        return axiosGetData(referenceAxiosInstance, `${searchUrl}/${key}`, []).then(res => {
            const data = res.data;
            return data;
        }).catch(err => {
            return [];
        });
    }
    const onApply = async (rows: MovementPatternEntity[]): Promise<ResponseEntity> => {
        const applyUrl = "/v1/movementPatternApply"
        return await axiosPostData(referenceAxiosInstance, `${applyUrl}`, rows);
    }

    const onDtlApply = async (rows: MovementPatternDtlEntity[]): Promise<ResponseEntity> => {
        const applyUrl = "/v1/movementPatternDtlApply"
        return await axiosPostData(referenceAxiosInstance, `${applyUrl}`, rows);
    }

    const onSave = async (row: MovementPatternEntity): Promise<ResponseEntity> => {
        const saveUrl = "/v1/movementPatternSave"
        return await axiosPostData(referenceAxiosInstance, `${saveUrl}`, row);
    }


    return {
        onSave: onSave,
        onApply: onApply,
        onDtlApply: onDtlApply,
        searchAllMovementPatternList: searchAllMovementPatternList,
        searchMovementPatternDtlList: searchMovementPatternDtlList,
    }
}
